import { GetListResponse, instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { ResellersListItem } from "../../resellers.types";
import { GetResellersRequestParams } from "./getResellers.types";

export const requestGetResellers = async (
  params: GetResellersRequestParams
): Promise<GetListResponse<ResellersListItem>> => {
  return await instance.get(ApiRoutesResellers.Resellers, { params });
};
